import { render, staticRenderFns } from "./PermanentInstructions.vue?vue&type=template&id=2bbf7724&scoped=true&"
import script from "./PermanentInstructions.vue?vue&type=script&lang=js&"
export * from "./PermanentInstructions.vue?vue&type=script&lang=js&"
import style0 from "./PermanentInstructions.vue?vue&type=style&index=0&id=2bbf7724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbf7724",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VChip,VCol,VRow,VSimpleCheckbox})
